var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefit2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#32A861"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.125 27.3333C41.1875 27.3333 40.1542 29.1417 40.6708 30.5625L36.0208 35.2125C35.6333 35.0833 35.1167 35.0833 34.7292 35.2125L31.3708 31.8542C31.8875 30.4333 30.8542 28.625 28.9167 28.625C27.1083 28.625 25.9458 30.4333 26.4625 31.8542L20.5208 37.6667C19.1 37.2792 17.2917 38.3125 17.2917 40.25C17.2917 41.6708 18.4542 42.8333 19.875 42.8333C21.6833 42.8333 22.8458 41.025 22.3292 39.6042L28.1417 33.6625C28.5292 33.7917 29.0458 33.7917 29.4333 33.6625L32.7917 37.0208C32.4042 38.3125 33.4375 40.25 35.375 40.25C37.3125 40.25 38.3458 38.4417 37.8292 37.0208L42.4792 32.3708C43.9 32.7583 45.7083 31.725 45.7083 29.9167C45.7083 28.4958 44.5458 27.3333 43.125 27.3333ZM35.375 28.625L36.5375 25.9125L39.25 24.75L36.5375 23.5875L35.375 20.875L34.2125 23.5875L31.5 24.75L34.2125 25.9125L35.375 28.625ZM20.5208 31.2083L21.1667 28.625L23.75 27.9792L21.1667 27.3333L20.5208 24.75L19.875 27.3333L17.2917 27.9792L19.875 28.625L20.5208 31.2083Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit2);
export default __webpack_public_path__ + "static/media/benefit2.4a32195f78fc12c67744eb2508618ae7.svg";
export { ForwardRef as ReactComponent };